export type Status = {
  label: string;
  variant: StatusVariant;
};

export type StatusVariant = 'bold' | 'info' | 'warning' | 'feature';
